<script setup lang="ts">
import type { LessonRoomGuideCategory } from '@ts-lesson-room/enums'

import { getLessonRoomGuide } from '@config/lesson-room-guides'

import { AppImage } from '@UI/Images/AppImage'

defineOptions({
  name: 'LessonRoomGuideManual',
})

const props = defineProps<{
  category: LessonRoomGuideCategory
}>()

const guide = computed(() => getLessonRoomGuide(props.category))

const sections = computed(() => ('sections' in guide.value ? guide.value.sections : null))

const steps = computed(() => ('steps' in guide.value ? guide.value.steps : null))
</script>

<template>
  <div class="lesson-room-guide-manual">
    <p class="lesson-room-guide-manual__title btly-text-title-m">
      {{ guide.title }}
    </p>

    <template v-if="sections">
      <div
        v-for="section in sections"
        :key="section.label"
        class="lesson-room-guide-manual__section"
      >
        <span
          v-if="section.label"
          class="lesson-room-guide-manual__chip btly-text-title-m"
        >{{ section.label }}</span>

        <div class="lesson-room-guide-manual__steps">
          <div
            v-for="(step, index) in section.steps"
            :key="index"
            class="lesson-room-guide-manual__point"
          >
            <div class="lesson-room-guide-manual__order">
              <span class="lesson-room-guide-manual__num btly-text-body-l">{{ index + 1 }}.</span>
              <span class="lesson-room-guide-manual__text btly-text-body-l">{{ step.text }}</span>
            </div>
            <AppImage
              v-if="step.image"
              class="lesson-room-guide-manual__shot"
              :srcset="step.image.avif"
              :src="step.image.webp"
              :width="step.image.width"
              :height="step.image.height"
              :alt="`Step ${index + 1}`"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="steps">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="lesson-room-guide-manual__point"
      >
        <div class="lesson-room-guide-manual__order">
          <span class="lesson-room-guide-manual__num btly-text-body-l">{{ index + 1 }}.</span>
          <span class="lesson-room-guide-manual__text btly-text-body-l">{{ step.text }}</span>
        </div>
        <img
          v-if="step.image"
          class="lesson-room-guide-manual__img"
          :src="step.image"
          :alt="`Step ${index + 1}`"
        >
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/LessonRoom/LessonRoomGuideManual.scss" />
